import { render, staticRenderFns } from "./SearchUploadFiles.vue?vue&type=template&id=ff57cb98&scoped=true"
import script from "./SearchUploadFiles.vue?vue&type=script&lang=js"
export * from "./SearchUploadFiles.vue?vue&type=script&lang=js"
import style0 from "./SearchUploadFiles.vue?vue&type=style&index=0&id=ff57cb98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff57cb98",
  null
  
)

export default component.exports